module.exports = __webpack_public_path__ + "static/media/books.348d66fd.svg";